import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Tailwind-aware classnames helper. Wraps clsx so callers can pass
 * arrays/objects/conditionals, and pipes through tailwind-merge so
 * later utilities win when they conflict (e.g. `p-2` + `p-4` resolves
 * to `p-4`). Identical to the shadcn-style `cn` helper used by the
 * admin SPA, kept duplicated here so the widget bundle stays
 * self-contained for the CDN cutover.
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}
